<template>
	<div class="drip-campaigns-overview" data-tour="cc-drip-campaigns">
		<h1 class="page-title">Drip Campaigns</h1>
		<NotificationBar
			v-if="!userHasBlinkRegistration || !companyHasBlinkRegistration"
			class="notification"
			:icon="['far', 'exclamation-circle']"
		>
			<div>
				Sorry, Drip Campaigns are currently only available if you are
				setup with Blink+. To get setup with Blink+, please contact your
				UWM account executive at 1-800-981-8898. To learn more about
				Blink+, please
				<a
					href="https://www.uwm.com/manage-your-pipeline/blink"
					target="_blank"
					>click here</a
				>.
			</div>
		</NotificationBar>
		<p class="description">
			Nurture your Blink+ leads through a Drip Campaign, a set of
			pre-written automated email messages that are sent from you to your
			borrowers over a period of time to encourage them to complete their
			application.
		</p>
		<section
			v-if="!campaigns.error && !campaigns.loading"
			class="drip-campaign-cards"
			data-tour="cc-drip-campaigns-list"
		>
			<ImageCard
				class="campagin-card"
				v-for="item in campaigns.list"
				:key="item.dripCampaignId"
				:item="item.dripCampaignId"
				:cardWidth="260"
				:imageHeight="260"
				:title="item.title"
				:description="item.description"
				:isActive="item.settings.activeInd"
				:imageURL="item.thumbNailUri"
				@select="goToCampaign($event)"
			/>
		</section>
		<div class="spinner" v-else-if="!campaigns.error && campaigns.loading">
			<LoadingIcon />
		</div>
		<div class="error" v-else-if="campaigns.error">
			<p>{{ error }}</p>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

import ImageCard from '@/components/cards/ImageCard.vue';
import LoadingIcon from '@/components/global/LoadingIcon.vue';
import NotificationBar from '@/components/global/NotificationBar.vue';

export default {
	name: 'DripCampaignsOverview',
	components: {
		ImageCard,
		LoadingIcon,
		NotificationBar,
	},
	data() {
		return {
			error: null,
			bankrateList: [],
		};
	},
	computed: {
		...mapState({
			campaigns: (state) => state.dripCampaigns.all,
			companyHasBlinkRegistration: (state) =>
				state.companyProfile.blinkRegistrationInd,
			userHasBlinkRegistration: (state) =>
				state.profile.blinkRegistrationInd,
		}),
	},
	methods: {
		goToCampaign(dripCampaignId) {
			this.$router.push({
				name: 'drip-campaign-item',
				params: { dripCampaignId },
			});
		},
	},
	watch: {
		campaigns(allCampaigns) {
			this.error = allCampaigns.error
				? 'We were unable to get the Drip Campaigns information. Please try again in a few minutes.'
				: null;
		},
	},
};
</script>

<style lang="scss" scoped>
.drip-campaigns-overview {
	.description {
		max-width: 960px;
		@include rem(margin-bottom, 30px);
	}

	.notification {
		align-items: flex-start;
		max-width: 960px;
		@include rem('margin-bottom', 12px);
		@include rem('padding', 6px);
		min-height: auto;

		/deep/ .icon {
			@include rem('margin', 1px 6px 0 0);
		}
	}

	.drip-campaign-cards {
		display: flex;
		flex-wrap: wrap;
		@include rem(margin-left, -15px);

		@media screen and (min-width: 600px) {
			@include rem(margin-left, -30px);
		}

		.campagin-card {
			@include rem(margin-left, 15px);

			@media screen and (min-width: 600px) {
				@include rem(margin-left, 30px);
			}
		}
	}

	.drip-campaign-cards--feature-flag {
		border-bottom: 1px solid $b360-color--gray__lighter;

		h2 {
			@include rem('margin-bottom', 5px);
		}

		&:last-child {
			border: none;
		}
	}

	.error p {
		color: $error;
	}
}
</style>
